import * as React from "react";
import {
  CheckCircleIcon,
  BriefcaseIcon,
  AdjustmentsIcon,
  PhoneIcon,
  AtSymbolIcon,
  LocationMarkerIcon,
} from "@heroicons/react/outline";

export const Icon = ({ name = "CheckCircleIcon", className = "w-6 h-6" }) => {
  const icons = {
    CheckCircleIcon: <CheckCircleIcon className={className} />,
    BriefcaseIcon: <BriefcaseIcon className={className} />,
    AdjustmentsIcon: <AdjustmentsIcon className={className} />,
    PhoneIcon: <PhoneIcon className={className} />,
    AtSymbolIcon: <AtSymbolIcon className={className} />,
    LocationMarkerIcon: <LocationMarkerIcon className={className} />,
  };

  if (!icons[name]) return icons.CheckCircleIcon;

  return icons[name];
};
